import React, { useState } from 'reactn';
import { GithubPicker as Circle } from 'react-color';
import { Box, Center, HStack, Stack, Text, VStack } from '@chakra-ui/react';
// import { hexToRGB } from './aidesigner';

export default function ColorPicker({ c1, c2, c3, changeColor, isGarment = true, section = 1 }) {

    console.log("X9 - COLLL c1", c1)
    console.log("X9 - COLLL c2", c2)

    const availableColours = ['#fccfe5', '#b984c6', '#ff369b', '#d22b2b', '#0532a1', '#93bdc4', '#346a3f', '#5dd137', '#fae76d']
    const [color1, setColor1] = useState(c1.hex)
    const [color2, setColor2] = useState(c2.hex)
    const [color3, setColor3] = useState(c3 ? c3.hex : null)


    const colors1 = [...[c1.hex], ...availableColours]
    const colors2 = [...[c2.hex], ...availableColours]
    let colors3 = c3 ? [...[c3.hex], ...availableColours] : []

    const setCol1 = (selected) => {
        changeColor([
            { from: c1, to: selected.hex },
            { from: c2, to: color2 },
            { from: c3, to: color3 }
        ], isGarment, section)
        setColor1(selected.hex)
    }

    const setCol2 = (selected) => {
        changeColor([
            { from: c1, to: color1 },
            { from: c2, to: selected.hex },
            { from: c3, to: color3 }
        ], isGarment, section)
        setColor2(selected.hex)
    }

    const setCol3 = (selected) => {
        changeColor([
            { from: c1, to: color1 },
            { from: c2, to: color2 },
            { from: c3, to: selected.hex }
        ], isGarment, section)
        setColor3(selected.hex)
    }
    return (
        <Box width="100%" maxW={['600%', '600%', '600px', '600px']}>
            <VStack width="100%" direction={isGarment ? 'row' : 'column'} >

                <VStack width="100%">
                    <Text fontSize={['sm', 'sm', 'sm', 'sm']} mb="0" mt={0} color={'gray.600'}>
                        Garment colours
                    </Text>
                    <Box width="100%">
                        <Center>
                            <Circle
                                width={'unset'}
                                circleSpacing={4}
                                circleSize={26}
                                colors={colors1}
                                color={color1}
                                selected={color1}
                                onChangeComplete={(selected) => setCol1(selected)}
                            />
                        </Center>
                    </Box>
                </VStack>
                <VStack width="100%">
                    {/* <Text fontSize={['sm', 'sm', 'sm', 'sm']} mb="0" mt={0} color={'gray.600'}>
                        Colour 2
                    </Text> */}
                    <Box width="100%">
                        <Center>
                            <Circle
                                width={'unset'}
                                circleSpacing={4}
                                colors={colors2}
                                circleSize={26}
                                color={color2}
                                selected={color2}
                                onChangeComplete={(selected) => setCol2(selected)}
                            />
                        </Center>
                    </Box>
                </VStack>
                {isGarment &&
                    <VStack width="100%">
                        <Text fontSize={['sm', 'sm', 'sm', 'sm']} mb="0" mt={0} color={'gray.600'}>
                            Rib Colour
                        </Text>
                        <Box width="100%">
                            <Center>
                                <Circle
                                    width={'unset'}
                                    circleSpacing={4}
                                    colors={colors3}
                                    circleSize={26}
                                    color={color3}
                                    selected={color3}
                                    onChangeComplete={(selected) => setCol3(selected)}
                                />
                            </Center>
                        </Box>
                    </VStack>
                }
            </VStack>
        </Box>
    );
}